module.exports = __webpack_public_path__ + "static/img/1.1763fce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/front/threeD/17/1.png
// module id = uYyu
// module chunks = 2